import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import refreshAuth from "../services/refreshAuth";

let lastGlobalRefreshTime = 0;
const REFRESH_COOLDOWN_MS = 10000; // 10 seconds

function useRefreshAuthMutation(
  setTokenAction: ActionCreatorWithPayload<{ token: string }, string>,
) {
  const dispatch = useDispatch();

  return useMutation(
    ["refreshAuth"],
    async ({ token }: { token: string }) => {
      const now = Date.now();
      const timeSinceLastRefresh = now - lastGlobalRefreshTime;

      // Check cooldown
      if (timeSinceLastRefresh < REFRESH_COOLDOWN_MS) {
        const remainingSeconds = Math.ceil(
          (REFRESH_COOLDOWN_MS - timeSinceLastRefresh) / 1000,
        );
        console.warn(`Cooldown active. Wait ${remainingSeconds} seconds.`);
        return;
      }

      // Update last refresh time
      lastGlobalRefreshTime = now;
      return refreshAuth({ token });
    },
    {
      onSuccess: (data) => {
        const newToken = typeof data === "string" ? data : data?.token;

        if (newToken) {
          dispatch(setTokenAction({ token: newToken }));
        } else {
          console.warn("No token received from refresh response");
        }
      },
      onError: (error) => {
        console.error("Token refresh failed:", error);
      },
    },
  );
}

export default useRefreshAuthMutation;
